function SummaryDeltaNeutral({ value }) {
  return (
    <div className="text-muted">
      (+{value})
    </div>
  )
}

module.exports = SummaryDeltaNeutral;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/components/Dashboard/SummaryDelta/summary-delta-neutral.jsx